<template>
  <div class="indexList Homenewslistindex titlesTop">
    <headTitle :title="$route.query.name" />
    <div class="haveContent" id="haveContent" v-if="listAllData">
      <mescroll-vue
        ref="mescroll"
        :up="mescrollUp"
        @init="mescrollInit"
        class="gundong"
        style="height: 100%"
      >
        <!-- 轮播图 -->
        <!-- <div class="swiperBox" v-if="listAllData.HD && listAllData.HD.length">
          <div class="swiper-container myswiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in listAllData.HD" :key="index">
                <div class="thumbImg">
                  <div class="linearback"></div>
                  <p class="thumbImgTitle">{{ item.mainContributionTitle }}</p>
                  <img
                    v-if="JSON.parse(item.contributionCover)[0]"
                    :src="JSON.parse(item.contributionCover)[0]"
                    alt
                  />
                  <img v-else src="../../assets/images/default.png" alt />
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>-->

        <div
          class="swiperBox"
          v-if="listAllData.HD && listAllData.HD.length"
          @touchstart.stop
          @touchmove.stop
          @touchend.stop
        >
          <van-swipe :autoplay="3000" class="swiper-container">
            <van-swipe-item
              v-for="(item, index) in listAllData.HD"
              :key="index"
              @click="goToArticle(item)"
            >
              <div class="thumbImg">
                <div class="linearback"></div>
                <p class="thumbImgTitle">{{ item.mainContributionTitle }}</p>
                <img
                  v-if="JSON.parse(item.contributionCover)[0]"
                  :src="JSON.parse(item.contributionCover)[0]"
                  alt
                />
                <img v-else src="../../assets/images/default.png" alt />
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>

        <!-- 新闻列表 -->
        <div class="newsBox">
          <div class="borderBox"></div>
          <newslist :listcontent="newsDataList"></newslist>
        </div>
      </mescroll-vue>
    </div>
    <loading :iscomplete="listAllData ? false : true"></loading>
  </div>
</template>

<script>
// import Swiper from "swiper";
// import "../../assets/swiper.min.css";
import newslist from "./NewsList.vue"; //新闻列表
import loading from "./loading.vue"; //加载动画
//import roofPlacement from './roofPlacement.vue'
import MescrollVue from "mescroll.js/mescroll.vue"; //上拉加载，下拉刷新
import Homeapi from "@/api/home";
import { Toast } from 'vant';
export default {
  props: {
    myIndex: {
      type: Number,
      default: () => 1, //必须是一个函数
      required: false, //不是必填项
    },
  },
  data() {
    return {
      listAllData: [], //页面数据
      newsDataList: [], //新闻列表
      swiperContent: null, //轮播图
      mescroll: null, // mescroll实例对象
      mescrollUp: {
        callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
        page: {
          num: 0, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
          rows: 10, // 每页数据的数量
        },
        htmlLoading:
          '<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">加载中..</p>',
        htmlNodata: '<p class="upwarp-nodata">-- 到底啦 --</p>',
        noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        toTop: {
          src: require("../../assets/mescroll/mescroll-totop.png"), // 回到顶部按钮的图片路径,支持网络图
        },
        auto: true,
        lazyLoad: {
          use: true, // 是否开启懒加载,默认false
        },
      },
      dataLink: "",
      columnId: "",
    };
  },
  components: {
    newslist, //新闻列表
    loading,
    MescrollVue,
    // roofPlacement //置顶
  },
  mounted() {
    // console.log(this.$route.query);
    this.dataLink = this.$route.query.datalink;
    this.columnId = this.$route.query.columnId ? this.$route.query.columnId : 0;
  },
  methods: {
    goToArticle(val) {
      var link;
      if (val.contributionOtherUrl) {
        link = val.contributionOtherUrl; //链接
      } else if (val.contributionType == "IMAGE_TYPE") {
        link = window.location.href.split("#/")[0] + "#/tabloid?id=" + val.id; //链接
        // return false;
      } else {
        link = window.location.href.split("#/")[0] + "#/detailsTwo?id=" + val.id; //链接
      }
      window.location.href = link;
    },
    // 头部新闻轮播图
    // InitializationSwiper() {
    //   if (this.swiperContent) {
    //     this.swiperContent.destroy();
    //   }
    //   var that = this;
    //   this.swiperContent = new Swiper(".myswiper", {
    //     direction: "horizontal", // 垂直切换选项
    //     loop: true, // 循环模式选项
    //     touchMoveStopPropagation: true, //阻止事件冒泡

    //     autoplay: {
    //       delay: 3000,
    //       stopOnLastSlide: false,
    //       disableOnInteraction: false,
    //     },

    //     // 如果需要分页器
    //     pagination: {
    //       el: ".swiper-pagination",
    //     },

    //     on: {
    //       click: function () {
    //         var x;
    //         if (this.clickedIndex == that.listAllData.HD.length + 1) {
    //           x = that.listAllData.HD[0];
    //         } else if (this.clickedIndex == 0) {
    //           x = that.listAllData.HD[that.listAllData.HD.length - 1];
    //         } else {
    //           x = that.listAllData.HD[this.clickedIndex - 1];
    //         }

    //         // console.log(x);
    //         var link;
    //         if (x.contributionOtherUrl) {
    //           link = x.contributionOtherUrl; //链接
    //         } else if (x.contributionType == "IMAGE_TYPE") {
    //           link =
    //             window.location.href.split("#/")[0] + "#/tabloid?id=" + x.id; //链接
    //           // return false;
    //         } else {
    //           link =
    //             window.location.href.split("#/")[0] + "#/detailsTwo?id=" + x.id; //链接
    //         }
    //         window.location.href = link;
    //       },
    //     },
    //   });
    // },
    mescrollInit(mescroll) {
      this.mescroll = mescroll;
    },
    // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
    upCallback(page, mescroll) {
      let params = {
        page: page.num,
        rows: page.rows,
        appName: this.appName,
        columnId: this.columnId,
      };

      Homeapi.getContribution(params, this.dataLink)
        .then((resp) => {
          console.log("1");
          console.log(resp);
          if (resp.success) {
            if (page.num === 1) {
              this.listAllData = resp.data;
              this.newsDataList = [];
              if (this.listAllData.HD) {
                // this.$nextTick(() => {
                //   this.InitializationSwiper();
                // });
              }
            }
            if (resp.data.pageList) {
              this.newsDataList = this.newsDataList.concat(
                resp.data.pageList.items
              );
            }
          } else {
            // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
            mescroll.endErr();
          }
          this.$nextTick(() => {
            if (resp.data.pageList.items) {
              mescroll.endSuccess(resp.data.pageList.items.length);
            } else {
              mescroll.endSuccess(0);
            }
          });
        })
        .catch(() => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          mescroll.endErr();
        });
    },
  },
};
</script>

<style>
.Homenewslistindex .swiper-pagination-bullet {
  background: #fff;
  opacity: 1;
}
.Homenewslistindex
  .swiper-container-horizontal
  .swiper-pagination-bullet-active {
  background: #1377e2;
}
.Homenewslistindex .mescroll-empty {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 20vw;
}
</style>

<style scoped>
.indexList {
  width: 100%;
  height: 100%;
  position: relative;
}
.indexList .swiper-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}
/* .indexList .swiper-hei {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
} */
.ellipsis-m {
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.swiperBox {
  width: 100%;
  padding-bottom: 60%;
  position: relative;
}
.indexList .haveContent {
  width: 100%;
  height: 100%;
}
.indexList .thumbImg {
  width: 100%;
  height: 100%;
  position: relative;
}
.indexList .thumbImg .thumbImgTitle {
  width: 80%;
  position: absolute;
  left: 10%;
  bottom: 0.6rem;
  color: #fff;
  text-shadow: 0.2em 0.2em 0.2em #000;
  text-align: center;
  font-size: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.indexList .thumbImg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.indexList .titleBunner {
  position: absolute;
  width: 100%;
  height: 20%;
  bottom: 0px;
  color: #333;
  font-size: 0.28rem;
  font-weight: 700;
  padding: 0px 10px;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: #e6e6e6;
  padding-top: 5px;
}
.titleIndex {
  position: absolute;
  bottom: 0;
  right: 5px;
  font-size: 0.24rem;
  color: #ababab;
}
.titleIndex span {
  color: red;
  font-weight: 100;
}
.borderBox {
  /* border:  solid#e6e6e6; */
  /* width: 100%; */
  /* margin-top: -50px; */
}
/* .newsBox{
        margin-top: 18px;
    } */
.outSwiper {
  /* margin-top: 5px; */
  margin: 10px auto;
}
.my-swipe .van-swipe-item {
  font-size: 20px;
  display: flex;
  justify-content: space-between;
}
.imgBox {
  /* margin: 0 1px; */
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.imgBox img {
  width: 35px;
  height: 35px;
}
.outerTitle {
  font-size: 14px;
}
.ellipsis-m {
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.indexList .thumbImg {
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );

  width: 100%;
  height: 100%;
  position: relative;
}
.indexList .thumbImg .linearback {
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
}
</style>